var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_45",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8035 20.5077L11.2535 13.9462C10.8819 14.1179 10.5026 14.2532 10.1158 14.352C9.72894 14.4507 9.31844 14.5 8.88428 14.5C7.35661 14.5 6.05803 13.9653 4.98853 12.8958C3.91903 11.8264 3.38428 10.5278 3.38428 9C3.38428 8.56667 3.43236 8.14967 3.52853 7.749C3.62469 7.34833 3.76511 6.96408 3.94978 6.59625L7.48428 10.0923L9.97678 7.6L6.51903 4.10375C6.88703 3.91925 7.26553 3.7725 7.65453 3.6635C8.04353 3.5545 8.45344 3.5 8.88428 3.5C10.4121 3.5 11.7108 4.03475 12.7803 5.10425C13.8496 6.17358 14.3843 7.47217 14.3843 9C14.3843 9.46033 14.3382 9.88375 14.246 10.2702C14.1537 10.6567 14.0152 11.0231 13.8305 11.3692L20.392 17.9193C20.5409 18.0724 20.6153 18.2575 20.6153 18.4745C20.6153 18.6915 20.5423 18.8729 20.3963 19.0188L18.8648 20.5505C18.7189 20.6963 18.5428 20.7628 18.3363 20.75C18.1299 20.7372 17.9524 20.6564 17.8035 20.5077ZM18.3555 19.6327L19.5113 18.477L12.592 11.5577C12.8535 11.1987 13.0509 10.7984 13.1843 10.3568C13.3176 9.91508 13.3843 9.46283 13.3843 9C13.3843 7.782 12.9129 6.69 11.97 5.724C11.027 4.758 9.81769 4.36667 8.34203 4.55L10.8268 7.0345C10.9883 7.19617 11.069 7.38467 11.069 7.6C11.069 7.81533 10.9883 8.00383 10.8268 8.1655L8.04978 10.9423C7.88828 11.1038 7.69978 11.1845 7.48428 11.1845C7.26894 11.1845 7.08053 11.1038 6.91903 10.9423L4.43428 8.45775C4.28944 10.0744 4.70644 11.3189 5.68528 12.1912C6.66411 13.0638 7.73044 13.5 8.88428 13.5C9.32628 13.5 9.76819 13.4365 10.21 13.3095C10.6519 13.1827 11.0606 12.984 11.4363 12.7135L18.3555 19.6327Z",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.0ed42e42d0aa83857ae1809d370e0379.svg";
export { ForwardRef as ReactComponent };